var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5584 4.35817C16.2167 4.22484 14.875 4.12484 13.525 4.04984V4.0415L13.3417 2.95817C13.2167 2.1915 13.0334 1.0415 11.0834 1.0415H8.90005C6.95838 1.0415 6.77505 2.1415 6.64172 2.94984L6.46672 4.0165C5.69172 4.0665 4.91672 4.1165 4.14172 4.1915L2.44172 4.35817C2.09172 4.3915 1.84172 4.69984 1.87505 5.0415C1.90838 5.38317 2.20838 5.63317 2.55838 5.59984L4.25838 5.43317C8.62505 4.99984 13.0251 5.1665 17.4417 5.60817C17.4667 5.60817 17.4834 5.60817 17.5084 5.60817C17.8251 5.60817 18.1001 5.3665 18.1334 5.0415C18.1584 4.69984 17.9084 4.3915 17.5584 4.35817Z",
    fill: "black",
    fillOpacity: 0.88
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.025 6.7835C15.825 6.57516 15.55 6.4585 15.2666 6.4585H4.73329C4.44995 6.4585 4.16662 6.57516 3.97495 6.7835C3.78329 6.99183 3.67495 7.27516 3.69162 7.56683L4.20829 16.1168C4.29995 17.3835 4.41662 18.9668 7.32495 18.9668H12.675C15.5833 18.9668 15.7 17.3918 15.7916 16.1168L16.3083 7.57516C16.325 7.27516 16.2166 6.99183 16.025 6.7835ZM11.3833 14.7918H8.60829C8.26662 14.7918 7.98329 14.5085 7.98329 14.1668C7.98329 13.8252 8.26662 13.5418 8.60829 13.5418H11.3833C11.725 13.5418 12.0083 13.8252 12.0083 14.1668C12.0083 14.5085 11.725 14.7918 11.3833 14.7918ZM12.0833 11.4585H7.91662C7.57495 11.4585 7.29162 11.1752 7.29162 10.8335C7.29162 10.4918 7.57495 10.2085 7.91662 10.2085H12.0833C12.425 10.2085 12.7083 10.4918 12.7083 10.8335C12.7083 11.1752 12.425 11.4585 12.0833 11.4585Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5d83d2da1882460c4b52c9b5a3aed103.svg";
export { ForwardRef as ReactComponent };